
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Website, WebsiteComposite, WebsiteStatus } from '@/services/Website/interfaces';

export interface RedisManageData {
  status?: string;
  enabled?: boolean;
  redisError?: string;
}

@Component
export default class RedisManagePanel extends Vue {
  @Prop({ type: Object, required: true })
  public composite!: WebsiteComposite;

  @Prop({ type: Boolean, default: false })
  public busy!: boolean;

  @Prop({ type: String, default: '' })
  public errorMessage!: string;

  @Prop({ type: Object, default: () => ({}) })
  public panelData!: RedisManageData;

  public get website(): Website {
    return this.composite.website;
  }

  public get enabled(): boolean {
    return !!(this.panelData && this.panelData.enabled);
  }

  public get mutationsAllowed(): boolean {
    return this.website.status === WebsiteStatus.ACTIVE;
  }

  public emitSubmit(operation: string, payload: Record<string, unknown> = {}): void {
    this.$emit('submit', { operation, ...payload });
  }
}
